import React from "react";

export const TopArtistCard = ({ data }) => {
  const topArtistUrl = data.artist_id.artwork;
  const topArtistName = data.artist_id.name;
  const topArtistRank = data.rank;
  const trackPlayed = data.play_count;

  return (
    <div className="top-artist-card">
      <div className="top-artist-card-header">
        <h3>Your top artist</h3>
        <h2 className="">{topArtistName}</h2>
      </div>

      <div className="artist-cover-container">
        <img
          referrerPolicy="no-referrer"
          src={topArtistUrl}
          alt="airbuds yearly recap"
          className="artist-capsule top-artist-cover "
        />

        <img
          src={require("../assets/img/badge.svg")}
          alt="top badge"
          className="top-artist-badge"
        />
      </div>

      <div className="track-played-container">
        <h2 className="track-played">{trackPlayed}</h2>
        <p className="track-played-subtitle">tracks played</p>
      </div>

      <div className="track-rank-container">
        <p className="track-rank">You're ranked #{topArtistRank}</p>
        <p className="track-rank-subtitle">of all airbuds users</p>
      </div>
    </div>
  );
};
